<template>
  <nav class="sidebar__nav">
    <ul>
      <modules-section :user="user" v-if="!user.isValidator" />
      <social-section :user="user" v-if="!user.isTemplate" />
      <traqing-section
        :user="user"
        v-if="!user.isValidator && !user.isTemplate"
      />
      <approve-section :user="user" v-if="!user.isUser && !user.isTemplate" />
      <rewards-section :user="user" v-if="user.isUser" />

      <profile-section :user="user" />
    </ul>
  </nav>
</template>

<script>
import ModulesSection from "Public/components/SideNav/SideNavSections/ModulesSection";
import TraqingSection from "Public/components/SideNav/SideNavSections/TraqingSection";
import RewardsSection from "Public/components/SideNav/SideNavSections/RewardsSection";
import SocialSection from "Public/components/SideNav/SideNavSections/SocialSection";
import ProfileSection from "Public/components/SideNav/SideNavSections/ProfileSection";
import ApproveSection from "Public/components/SideNav/SideNavSections/ApproveSection";
export default {
  name: "SideNavSections",
  components: {
    ApproveSection,
    ProfileSection,
    SocialSection,
    RewardsSection,
    TraqingSection,
    ModulesSection,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped></style>
